export { default as PreRequestsList } from "./List";
export { default as PreRequestDetail } from "./Detail";
